// import 'es6-shim';  // hopefully not necessary with babel
import 'jquery';
// import 'lightcase';
import lity from 'lity';
import jcf, { applyJcfDropdownZIndexFix } from '../../UM-Base/lib/jcf';
import Flickity from 'flickity';

export default {
  init(components) {
    // console.log('jQuery v', jQuery().jquery);
    // console.log(lity);

    Flickity.defaults.dragThreshold = 20;

    // JavaScript to be fired on all pages
    // remove below because i couln't find data-toggle="more" in our code. So I assume it's legacy code.
    // $('[data-toggle="more"]').on('click', (e) => {
    //   const target = document.querySelector(e.currentTarget.getAttribute('data-target'));

    //   if (target) {
    //     $(e.currentTarget).slideUp(400, () => $(e.currentTarget).remove()).fadeOut(200);
    //     $(target).slideDown();
    //   }
    // });

    // Disable transition during a resize
    $(window).on(
      'resize',
      window.requestAnimationFrame.bind(window, () => {
        $('body').addClass('no-transition');

        setTimeout(
          window.requestAnimationFrame.bind(
            window,
            () => {
              $('body').removeClass('no-transition');
            },
            50
          )
        );
      })
    );

    jcf.replaceAll();
    applyJcfDropdownZIndexFix();

    // jcf.replaceAll('#result-grid select, #result-grid input[type="checkbox"], #result-grid input[type="radio"], #search-filters-tray #search-filters-type-wrapper, #search-filters-tray button, #search-filters-tray fieldset, .search-layout__filters label');
    // , #footer__wrapper select, .footer__lang select

    // analytics on close (triggered before the lightbox is closed)
    $(document).on('lity:close', function (event, instance) {
      // console.log('Lightbox closed', instance);
      var opener = instance.opener();
      console.log('opener', opener);
      if (typeof _satellite != 'undefined') {
        _satellite.setVar('popUpVideoName', opener.title);
        _satellite.track('popupVideoClosed');
      }
    });

    // analytics on open
    $(document).on('lity:open', function (event, instance) {
      // console.log('Lightbox opened', event);
      var opener = instance.opener();
      console.log('opener', opener);
      if (typeof _satellite != 'undefined') {
        _satellite.setVar('popUpVideoName', opener.title);
        _satellite.track('popupVideoOpened');
      }
    });

    // $('[data-lightbox]').lity({
    //   onFinish: {
    //     corge: function corge() {
    //       $("#lightcase-content iframe").each(function (n) {
    //         $(this).attr("id", "player" + n);
    //         $(this).after("<script src='/static/dtm-youtube-api.js'></script>");
    //   });
    //       _satellite.setVar('popUpVideoName', $(this).attr("title"));
    //       _satellite.track('popupVideoOpened');
    //     }
    //   },
    //   onClose : {
    //     grault: function grault() {
    //   // location.reload(); // reloading the page is a poor solution
    //       _satellite.setVar('popUpVideoName', $(this).attr("title"));
    //       _satellite.track('popupVideoClosed');
    //     }
    //   }
    // });

    $('a, button, [type="button"]').on('click', (e) => {
      // If this is a mouse click (rather than an enter click), don't apply focus styling
      if (typeof e.originalEvent !== 'undefined' && e.originalEvent.detail > 0) {
        $(e.currentTarget).blur();
      }
    });
  },

  finalize() {
    $('body').addClass('stage-1-loaded stage-2-loaded');
  },
};
